module.exports = __webpack_public_path__ + "static/media/card_back.5e6c2f68.png";